import React from 'react';
import { Link } from 'react-router-dom';
 
class WhyUs extends React.Component {
    render(){
        return (
            <section id="Offrings" className="why-choose-us">
                {/* .single-box .content */}
                <div className="row m-0 ">
                    <div className="col-lg-3 col-sm-6 p-0">
                        <div className="single-box">
                            <div className="d-table">
                                <div className="d-table-cell">
                                    <div  className="content">
                                        <div className="icon">
                                            <i className="icofont-headphone-alt-1"></i>
                                        </div>
                                        <h3> New Year Parties </h3>
                                        <p>Celebrate the countdown with vibrant themes, music, and memories! </p>
            
                                        {/* <Link to="#" className="btn btn-primary">Read More</Link> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-sm-6 p-0">
                        <div className="single-box">
                            <div className="d-table">
                                <div className="d-table-cell">
                                    <div className="content">
                                        <div className="icon">
                                            <i className="icofont-travelling"></i>
                                        </div>
                                        <h3>Travel And Tour Packages </h3>
                                        <p>Handpicked journeys to the most stunning destinations worldwide.</p>
            
                                        {/* <Link to="#" className="btn btn-primary">Read More</Link> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-sm-6 p-0">
                        <div className="single-box">
                            <div className="d-table">
                                <div className="d-table-cell">
                                    <div className="content">
                                        <div className="icon">
                                            <i className="icofont-map"></i>
                                        </div>
                                        <h3>Adventures</h3>
                                        <p> Guided adventures to explore culture, nature, and hidden gems. </p>
            
                                        {/* <Link to="#" className="btn btn-primary">Read More</Link> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-sm-6 p-0">
                        <div className="single-box">
                            <div className="d-table">
                                <div className="d-table-cell">
                                    <div className="content">
                                        <div className="icon">
                                            <i className="icofont-wink-smile"></i>
                                        </div>
                                        <h3> Events  </h3>
                                        <p> Exclusive experiences designed to inspire and entertain. </p>
            
                                        {/* <Link to="#" className="btn btn-primary">Read More</Link> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row m-0 ">
                    <div className="col-lg-3 col-sm-6 p-0">
                        <div className="single-box">
                            <div className="d-table">
                                <div className="d-table-cell">
                                    <div  className="content">
                                        <div className="icon">
                                            <img  src='/assets/images/noun-wedding-6447492.svg' style={{width: 45, height: 49}}></img>
                                        </div>
                                        <h3>Wedding Creatives</h3>
                                        <p>Stunning visual and artistic designs tailored to create your dream wedding.   </p>
            
                                        {/* <Link to="#" className="btn btn-primary">Read More</Link> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-sm-6 p-0">
                        <div className="single-box">
                            <div className="d-table">
                                <div className="d-table-cell">
                                    <div className="content">
                                        <div className="icon">
                                        <img  src='/assets/images/noun-artist-7227705.svg' style={{width: 45, height: 45}}></img>
                                        </div>
                                        <h3>Artists </h3>
                                        <p>Collaborate with talented performers to elevate your event with unforgettable acts.</p>
            
                                        {/* <Link to="#" className="btn btn-primary">Read More</Link> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-sm-6 p-0">
                        <div className="single-box">
                            <div className="d-table">
                                <div className="d-table-cell">
                                    <div className="content">
                                        <div className="icon">
                                        <img  src='/assets/images/noun-sound-effects-6743090.svg' style={{width: 45, height: 49}}></img>
                                        </div>
                                        <h3>Sound & Production</h3>
                                        <p> High-quality audio and production setups for seamless event experiences. </p>
            
                                        {/* <Link to="#" className="btn btn-primary">Read More</Link> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-sm-6 p-0">
                        <div className="single-box">
                            <div className="d-table">
                                <div className="d-table-cell">
                                    <div className="content">
                                        <div className="icon">
                                        <img  src='/assets/images/concerts.svg' style={{width: 45, height: 49}}></img>
                                        </div>
                                        <h3> Concerts  </h3>
                                        <p> Bringing live music to life with top-notch planning and execution. </p>
            
                                        {/* <Link to="#" className="btn btn-primary">Read More</Link> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <ul className='slideshow'>
                    <li><span></span></li>
                    <li><span></span></li>
                    <li><span></span></li>
                    <li><span></span></li>
                </ul>
            </section>
        );
    }
}
 
export default WhyUs;